import { render, staticRenderFns } from "./SlideRenderer.vue?vue&type=template&id=661cd172"
import script from "./SlideRenderer.vue?vue&type=script&lang=js"
export * from "./SlideRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports